import React from "react";
import {
  CButton,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CModalFooter,
} from "@coreui/react";
import { DatePicker, Flex, Input, Select, Typography } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { useState } from "react";
import { getPersonalPacket } from "src/store/Slices/ClientsSlice";
import { openNotification } from "src/components/helpers/notification";
import { useEffect } from "react";
import { getClientsList } from "src/store/Slices/ClientsSlice";

const AddPacket = ({ packetModal, setPacketModal, clientInfo, payload }) => {
  const dateFormatList = ["DD.MM.YYYY"];
  // HELPERS
  const dispatch = useDispatch();
  dayjs.extend(customParseFormat);
  const yesterdayDate = dayjs().subtract(1, "day").format("DD.MM.YYYY");
  //STORE
  const packetsList = useSelector((state) => state.ClientsSlice.packetsList);
  // STATE
  const [userId, setUserId] = useState(null);
  const [personalPacketId, setPersonalPacketId] = useState(false);
  const [trainingLeft, setTrainingLeft] = useState();
  const [datePurchased, setDatePurchased] = useState(dayjs());

  // FUNCTIONS
  const onClickAddPacket = () => {
    if (!(userId && personalPacketId && datePurchased)) {
      openNotification({
        type: "error",
        message: `Заполните поля`,
      });
    } else {
      dispatch(
        getPersonalPacket({
          flag: "put",
          value: {
            userId: userId,
            personalPacketId: personalPacketId,
            trainingLeft: trainingLeft,
            datePurchased: datePurchased,
          },
        })
      ).then(() => {
        dispatch(
          getPersonalPacket({ flag: "get", value: { UserId: clientInfo?.id } })
        );
        dispatch(getClientsList(payload));
        setPacketModal(false);
      });
    }
  };

  useEffect(() => {
    setUserId(clientInfo.id);
  }, [packetModal]);

  return (
    <CModal
      alignment="center"
      visible={packetModal}
      aria-labelledby="VerticallyCenteredExample"
      onClose={() => {
        setPacketModal(false);
      }}
      keyboard={true}
    >
      <CModalHeader>
        <CModalTitle id="VerticallyCenteredExample">
          {"Добавить пакет"}
        </CModalTitle>
      </CModalHeader>
      <CModalBody
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        <Flex vertical gap={16} style={{ marginTop: "20px" }}>
          <>
            <div>
              <Typography.Title level={5}>
                Id персонального пакета
              </Typography.Title>
              <Select
                showSearch
                optionFilterProp="label"
                style={{ width: "100%" }}
                options={packetsList?.data?.value}
                onChange={(value, opt) => {
                  setPersonalPacketId(value);
                  console.log(opt);
                  setTrainingLeft(opt.trainingCount);
                }}
                placeholder={"Выбрать"}
                value={personalPacketId}
              />
            </div>
            <div>
              <Typography.Title level={5}>Остаток тренировок</Typography.Title>
              <Input
                defaultValue=""
                type="number"
                value={trainingLeft}
                onChange={(e) => {
                  setTrainingLeft(
                    parseInt(
                      e.currentTarget.value >= 0 ? e.currentTarget.value : ""
                    )
                  );
                }}
              />
            </div>
            <div>
              <Typography.Title level={5}>Дата покупки</Typography.Title>
              <DatePicker
                style={{ width: "100%" }}
                format={"DD.MM.YYYY"}
                placement={"topRight"}
                onChange={(date, dateString) => {
                  setDatePurchased(date);
                }}
                value={datePurchased && dayjs(datePurchased)}
              />
            </div>
          </>
        </Flex>
      </CModalBody>
      <CModalFooter>
        <CButton
          onClick={() => {
            setPacketModal(false);
          }}
          style={{ color: "#fff" }}
          color="secondary"
        >
          Закрыть
        </CButton>
        <CButton onClick={onClickAddPacket} style={{ color: "#fff" }}>
          Добавить
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default AddPacket;
